import { useState, useRef, useEffect } from "react";
import { Search, ChevronDown, X } from "lucide-react";

export default function SearchSelect({ options = [], value = "", onChange, placeholder = "Pilih...", allLabel = "Semua", testid }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = options.filter((o) => o.toLowerCase().includes(query.toLowerCase())).slice(0, 30);

  const pick = (v) => { onChange(v); setOpen(false); setQuery(""); };

  return (
    <div className="relative min-w-[160px]" ref={ref} data-testid={testid}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm hover:border-sky-300 transition">
        <span className={value ? "text-slate-800" : "text-slate-400"}>{value || placeholder}</span>
        {value ? <X className="w-3.5 h-3.5 text-slate-400" onClick={(e) => { e.stopPropagation(); pick(""); }} /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
      </button>
      {open && (
        <div className="absolute z-30 mt-1.5 w-full bg-white rounded-xl border border-slate-100 shadow-lg max-h-72 overflow-hidden">
          <div className="p-2 border-b border-slate-50 relative">
            <Search className="w-3.5 h-3.5 text-slate-400 absolute left-4 top-4" />
            <input autoFocus value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Cari lokasi..."
              data-testid={testid ? `${testid}-input` : undefined}
              className="w-full rounded-lg border border-slate-200 pl-8 pr-3 py-1.5 text-sm outline-none focus:border-sky-400" />
          </div>
          <div className="max-h-56 overflow-y-auto py-1">
            <button type="button" onClick={() => pick("")} className="w-full text-left px-4 py-2 text-sm hover:bg-sky-50 text-slate-500">{allLabel}</button>
            {filtered.length === 0 ? <p className="px-4 py-3 text-xs text-slate-400">Tidak ada hasil.</p> :
              filtered.map((o) => (
                <button type="button" key={o} onClick={() => pick(o)}
                  className={`w-full text-left px-4 py-2 text-sm hover:bg-sky-50 ${value === o ? "text-sky-600 font-semibold" : "text-slate-700"}`}>{o}</button>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
